<template>
<div :class="['wrapper', classes]">
  <header class="main-header">

    <!-- <span class="logo-mini">
      <a href="/"><img src="/static/img/relitrade.png" id="logo" alt="Logo" class="img-responsive center-block logo" width="150px"></a>
    </span> -->

    <!-- Header Navbar -->
    <nav class="navbar navbar-static-top" role="navigation">
      <!-- Sidebar toggle button-->

      <a href="javascript:;" class="sidebar-toggle" data-toggle="offcanvas" role="button">
        <span class="sr-only">Toggle navigation</span>&nbsp&nbsp&nbsp
        <img src="/static/img/logo.png"/>
      </a>
 
      <!-- Navbar Right Menu -->
      <div class="navbar-custom-menu">
        <ul class="nav navbar-nav">

          <!-- User Account Menu -->
          <li class="dropdown user user-menu" v-on:click="Logout()">
            <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown">
              <span class="hidden-xs fa fa-power-off"></span>
            </a>
          </li>
        </ul>
      </div>
    </nav>
  </header>
  <!-- Left side column. contains the logo and sidebar -->
  <sidebar :display-name="demo.displayName" :picture-url="demo.avatar" />

  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        {{$route.name.toUpperCase() }}
        <small>{{ $route.meta.description }}</small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="javascript:;">
            <i class="fa fa-home"></i>Home</a>
        </li>
        <li class="active">{{$route.name.toUpperCase()}}</li>
      </ol>
    </section>

    <router-view></router-view>
  </div>

  <!-- /.content-wrapper -->

  <!-- Main Footer -->
  <footer class="main-footer">
    <!-- <strong>Copyright &copy; {{year}}
      <a href="javascript:;">CoPilot</a>.</strong> All rights reserved. -->
  </footer>
</div>
<!-- ./wrapper -->
</template>

<script>
import faker from 'faker'
import {
  mapState
} from 'vuex'
import config from '../config'
import Sidebar from './Sidebar'
import 'hideseek'
import {
  globalStore
} from '../main.js';
export default {
  name: 'Dash',
  components: {
    Sidebar
  },
  data: function() {
    return {
      // section: 'Dash',
      year: new Date().getFullYear(),
      classes: {
        fixed_layout: config.fixedLayout,
        hide_logo: config.hideLogoOnMobile
      },
      error: ''
    }
  },
  mounted: function() {
  //  this.CheckLogin();
  },
  computed: {
    ...mapState([
      'userInfo'
    ]),
    demo() {
      return {
        displayName: faker.name.findName(),
        avatar: faker.image.avatar(),
        email: faker.internet.email(),
        randomCard: faker.helpers.createCard()
      }
    }
  },
  methods: {
    CheckLogin() {
      // alert(localStorage.getItem('SocietyId'))
      if(localStorage.getItem('clientId') && localStorage.getItem('eventId')){
        console.log("Already Logged In");
        console.log("eventId: "+localStorage.getItem('eventId'));
        console.log("clientId: "+localStorage.getItem('clientId'));
        
      }
      else{
        console.log("Not Logged In")
        this.$router.push('/login')
      }
    },
    Logout() {
      console.log("Log Out Clicked")
      localStorage.removeItem("userId");
      localStorage.removeItem("clientId");
      localStorage.removeItem("eventId");
      localStorage.removeItem("token");
      this.$router.push('/login');
    },
  }
}
</script>

<style>
.wrapper.fixed_layout .main-header {
  position: fixed;
  width: 100%;
}

.wrapper.fixed_layout .content-wrapper {
  padding-top: 50px;
}

.wrapper.fixed_layout .main-sidebar {
  position: fixed;
  height: 100vh;
}

@media (max-width: 767px) {
  .wrapper.hide_logo .main-header .logo {
    display: none;
  }
}

img{
  width: 150px;
}


.logo-mini,
.logo-lg {
  text-align: left;
}

.logo-mini img,
.logo-lg img {
  padding: 0.4em !important;
}

.logo-lg img {
  display: -webkit-inline-box;
  width: 2%;
}

.user-panel {
  height: 4em;
}

.fa-power-off{
  color: red;
}

hr.visible-xs-block {
  width: 100%;
  background-color: rgba(0, 0, 0, 0.17);
  height: 1px;
  border-color: transparent;
}
</style>



// WEBPACK FOOTER //
// Dash.vue?5cd9fa27